<template>
  <span
    :class="componentClass"
    :style="componentStyle"
  >
    <span
      v-if="explanation"
      class="sr-only"
    >
      {{ explanation }}
    </span>
    {{ label }}
  </span>
</template>

<script>
  export default {
    name: 'Tag',

    props: {
      background: {
        type: String,
        default: null
      },
      color: {
        type: String,
        default: null
      },
      customStyle: {
        type: Object,
        default: () => {}
      },
      explanation: {
        type: String,
        default: null
      },
      isRounded: {
        type: Boolean,
        default: false
      },
      label: {
        type: String,
        default: null
      },
      position: {
        type: String,
        default: null
      },
      positionIndent: {
        type: String,
        default: null
      },
      size: {
        type: String,
        default: null
      },
      theme: {
        type: String,
        default: null
      }
    },

    computed: {
      hasPositioning() {
        return this.hasPosition && this.hasPositionIndent
      },
      componentClass() {
        return [`tag ${this.size} ${this.theme} ${this.position}`, { rounded: this.isRounded }]
      },
      componentStyle() {
        let style = {}

        if (this.background) {
          style['--tag-background'] = this.background
        }

        if (this.color) {
          style['--tag-color'] = this.color
        }

        if (this.hasPositioning) {
          style['right'] = this.positionIndent
        }

        return {
          ...style,
          ...this.customStyle
        }
      }
    }
  }
</script>
